import { z } from 'zod';
export const duplicateDecisionSchema = z.object({ kind: z.enum(['company', 'contact']), leftId: z.string().uuid(), rightId: z.string().uuid(), disposition: z.enum(['needs_review', 'keep_separate']), reason: z.string().trim().min(1).max(2000) });
export const duplicateEvaluationSchema = z.object({
    key: z.string().uuid(), kind: z.enum(['company', 'contact']), leftId: z.string().uuid(), rightId: z.string().uuid(),
    aiVerdict: z.enum(['same', 'different', 'uncertain']),
    aiReasonCodes: z.array(z.string().regex(/^[a-z][a-z0-9_]{1,63}$/)).min(1).max(20),
    model: z.string().regex(/^[A-Za-z0-9._:/-]{1,160}$/),
});
export const duplicateEvaluationRequestSchema = z.object({
    key: z.string().uuid(), kind: z.enum(['company', 'contact']), leftId: z.string().uuid(), rightId: z.string().uuid(),
});
export const duplicateEvaluationBackfillSchema = z.object({
    kind: z.enum(['company', 'contact']), dryRun: z.boolean(), limit: z.number().int().min(1).max(100).default(25),
    cursor: z.object({ leftId: z.string().uuid(), rightId: z.string().uuid() }).optional(),
});
export const identityAutomationPolicySchema = z.object({
    kind: z.enum(['company', 'contact']), model: z.string().regex(/^[A-Za-z0-9._:/-]{1,160}$/),
    validTo: z.string().datetime({ offset: true }), reason: z.string().trim().min(1).max(2000),
});
export const stopIdentityAutomationPolicySchema = z.object({ policyId: z.string().uuid(), reason: z.string().trim().min(1).max(2000) });
export const subjectLinkEvaluationRequestSchema = z.object({ key: z.string().uuid(), linkId: z.string().uuid() });
export const subjectLinkEvaluationBackfillSchema = z.object({
    kind: z.enum(['company', 'contact']), dryRun: z.boolean(), limit: z.number().int().min(1).max(100).default(25), cursor: z.string().uuid().optional(),
});
export const subjectLinkAutomationPolicySchema = z.object({
    kind: z.enum(['company', 'contact']), model: z.string().regex(/^[A-Za-z0-9._:/-]{1,160}$/), validTo: z.string().datetime({ offset: true }),
    reason: z.string().trim().min(1).max(2000),
});
//# sourceMappingURL=duplicates.js.map